


















































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { UserPermission } from "@/shared/types";
import * as RouteNames from "@/admin/route-names";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useSigningDocumentStore } from "@/admin/store/signingDocument";

@Component({
  components: {
  }
})
export default class SigningDocuments extends Vue {
  signingDocumentStore = useSigningDocumentStore();
  featureFlagStore = useFeatureFlagStore();
  rolePermissionsStore = useRolePermissionsStore();
  pageNumber: number;

  created (): void {
    this.signingDocumentStore.loadAllAdmin();
  }

  get hasEditPermission (): boolean {
    return this.featureFlagStore.flags.hsa4475allowRolePermissions
      ? this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalDocumentEdit)
      : true;
  }

  linkToDocumentEditor (documentId: number, version: number) {
    return {name: RouteNames.SigningDocumentEditor, params: { documentId: documentId.toString(), version: version.toString() }};
  }

  toTitleCase (txt: string) {
    if (txt) {
      return txt.charAt(0).toUpperCase() + txt.substring(1);
    } else {
      return "";
    }
  }

}
